import React from "react";
import Slider from "react-slick";
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
import { Container, Row, Col } from "reactstrap";

import Image from '../assets/images/panou-verde.jpg'

const SliderContainer = styled.div`
  background: white;
  color: black;
  padding: 1rem 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
`

const BackgroundUp = styled.div`
  background: linear-gradient(10deg,#fc9a57 5%, 40%,#dd45d3 90%);
  background: light;
  color: white;
  padding: 4rem 0;
  clip-path: polygon(0 0, 100% 0, 100% 75%, 0% 100%);
  text-align: center;
`

const BackgroundDown = styled.div`
  background: linear-gradient(10deg,#57c0fc 5%,#05f76e 40%,#06ba54 90%);
  background: light;
  color: white;
  padding: 4rem 0;
  clip-path: polygon(0 25%, 100% 0, 100% 100%, 0% 100%);
  text-align: center;
`

export default () => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const sideMetadata = useStaticQuery(graphql`
    query TitleQuery {
      site {
        siteMetadata {
          title
          author
        }
      }
    }
  `)

  let {title, author} = sideMetadata.site.siteMetadata
  return (
 
    <SliderContainer>
      <BackgroundUp>
      <Slider {...settings}>
                <div>
                  <div className="text-center">
                    <h1>{title="ECOGRAFIE"}</h1>
                    <p>Medimage {author}</p>
                  </div>
                </div>
                <div>
                  <div className="text-center">
                    <h1>{title="MAMOGRAFIE"}</h1>
                    <p>Medimage {author}</p>
                  </div>
                </div>
                <div>
                  <div className="text-center">
                    <h1>{title="RADIOLOGIE"}</h1>
                    <p>Medimage {author}</p>
                  </div>
                </div>
              </Slider>
      </BackgroundUp>

      <Container>
        <Row>
          <Col>

          </Col>
          <Col>
          <div className="text-center">
          <img src={Image} alt="Logo Medimage" height="200px"/>
        </div>
          </Col>
          <Col>

          </Col>
        </Row>
      </Container>

      <BackgroundDown >
      <h2 className="text-center mb-4">Servicii</h2>
      </BackgroundDown>
    </SliderContainer>



  )
}
